import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { HeatingDeviceContentProvider } from 'console/shared/contexts/heating-device';
import { DeviceContentProvider, } from 'console/shared/contexts/device';
import { CustomTabContent } from './content';
import { DefaultTabKey } from 'console/shared/content/tab/types';
export const CustomTab = memo(function CustomTab(props) {
    const { device, ui_group } = props;
    const { items: custom_content, id } = ui_group;
    const tab_key = useMemo(() => (custom_content && id
        ? `${DefaultTabKey.custom_tab}-${id}`
        : DefaultTabKey.heat_tab), [custom_content, id]);
    return (_jsx(DeviceContentProvider, { device: device, tab_key: tab_key, children: _jsx(HeatingDeviceContentProvider, { custom_content: custom_content, children: _jsx(CustomTabContent, {}) }) }));
});
